import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import ErrorScreen from "components/ErrorScreen"
import GlobalAuthObserver from "components/GlobalAuthObserver"
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom"
import { getAuthInfo } from "utils/auth"
import { routes } from "utils/routes"
import SSO from "views/auth/SSO"
import Home from "views/home"
import LeadGrowthForm from "views/leadGrowthForm"

const PrivateRoute = () => {
  const auth = getAuthInfo()
  return auth ? (
    <Outlet />
  ) : (
    <Navigate
      to={{
        pathname: routes.sso,
        search: `?next=${window.location.pathname}`,
      }}
      replace
    />
  )
}

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        /**
         * We don't want failed requests to be retried by default
         * We can enable this on a per-API basis
         */
        retry: false,
      },
    },
  })

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route element={<GlobalAuthObserver />} path="/">
            <Route element={<SSO />} path={routes.sso} />
            <Route element={<PrivateRoute />} path="/">
              <Route element={<LeadGrowthForm />} path={routes.user} />
              <Route element={<Home />} path={routes.home} />
            </Route>

            <Route
              element={<ErrorScreen error="Page not found" />}
              path={routes.pageNotFound}
            />
          </Route>
        </Routes>
      </Router>
    </QueryClientProvider>
  )
}

export default App
